import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Box,
  Typography,
  Button,
  CircularProgress,
  Grid,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import Carrousel from './Carrousel';
import CarrouselProducts from './CarrouselProducts';
import ProductCardDetail from './ProductCardDetail';
import ProductCardModal from './ProductCardModal';
import { setOpenProductModal } from '../../../../../../redux/actions/BankActions';

import { useExchangeBodyStyles } from './styles';

const ExchangeBody = ({ ...props }) => {
  const { categories, mobile } = props;
  const classes = useExchangeBodyStyles();
  const {
    categoriesStatus,
    currentCategory,
    points,
    currentProductCategory,
    openProductModal,
  } = useSelector((state) => state.bankReducer);

  const dispatch = useDispatch();

  const [categoryButtonSelected, setCategoryButtonSelected] = useState(false);
  const [productButtonSelected, setProductButtonSelected] = useState(false);

  const categoryIsSelected =
    Object.keys(currentCategory).length > 0 && categoryButtonSelected;

  const handleCategorySelected = (value) => {
    setCategoryButtonSelected(value);
    setProductButtonSelected(false);
  };

  const handleProductSelected = (value) => {
    setProductButtonSelected(value);
  };

  const onCloseModal = () => {
    dispatch(setOpenProductModal(false));
  };

  const isPointsRemainingError = () =>
    currentProductCategory &&
    Object.keys(currentProductCategory).length > 0 &&
    categoryIsSelected
      ? Math.sign(currentProductCategory.points - Number(points.Points)) > 0
      : false;

  useEffect(() => {
    setProductButtonSelected(false);
  }, [currentProductCategory]);

  useEffect(() => {
    setCategoryButtonSelected(false);
    setProductButtonSelected(false);
  }, []);

  return (
    <>
      <Paper className={classes.container} elevation={0}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography className={classes.title}>
            Canjear mis Ripley Puntos Go
          </Typography>
          {categoriesStatus === 'loading' && <CircularProgress />}
          {categoriesStatus === 'succeded' && (
            <>
              <Carrousel
                categories={categories}
                mobile={mobile}
                handleCategorySelected={handleCategorySelected}
              />
              {categoryIsSelected && (
                <Typography className={classes.subtitle}>
                  {currentCategory.actionSelectProduct}
                </Typography>
              )}
              {categoryButtonSelected && (
                <CarrouselProducts
                  mobile={mobile}
                  points={
                    Object.entries(points).length > 0
                      ? Number(points.Points)
                      : 0
                  }
                />
              )}
              {!categoryIsSelected && (
                <Button
                  data-cy="categoryButton"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => handleCategorySelected(true)}
                >
                  Canjear
                </Button>
              )}
              {categoryIsSelected && !productButtonSelected && (
                <Button
                  data-cy="productButton"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => handleProductSelected(true)}
                  disabled={isPointsRemainingError()}
                >
                  Canjear
                </Button>
              )}
              {productButtonSelected && (
                <Grid container>
                  <Grid item xs={12}>
                    <ProductCardDetail
                      mobile={mobile}
                      category={currentCategory}
                      handleProductSelected={handleProductSelected}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Box>
      </Paper>
      {Object.keys(currentProductCategory).length > 0 && (
        <ProductCardModal
          product={currentProductCategory}
          category={currentCategory}
          open={openProductModal}
          onClose={onCloseModal}
          mobile={mobile}
        />
      )}
    </>
  );
};

ExchangeBody.propTypes = {
  categories: PropTypes.array,
  mobile: PropTypes.bool,
};

export default ExchangeBody;
